import { Grid, useMediaQuery } from '@material-ui/core';
import React from 'react';
import { useFormikContext } from 'formik';
import { format } from 'date-fns';
import { AssuranceIcon } from 'images';
import { get } from 'lodash';
import { StoreContext } from 'utils/contextStore';
import frLocale from 'date-fns/locale/fr';
import arLocale from 'date-fns/locale/ar';
import formatBytes from 'utils/formatBytes';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { LANGUAGES } from 'store/LanguageProvider/constants';
import {
  ContentLeft,
  ContentRight,
  ContentSecondTitle,
  ContentTitle,
  FolderTypeSecondaryContent,
  PrimaryTitleCard,
  UploadBoxRecap,
  UploadBoxSecondTitle,
  UploadBoxTitle,
} from './styles';
import CardRecapComponent from './CardRecapComponent';
import { concernedPeopleMapping, foldersTypeListMapping } from './mapping';

interface DonneComplementairesType {
  email: string;
  telNumber: string;
  dateConsultation: string;
  fraisEngagement: string;
}
const DonneComplementaires = ({
  email,
  telNumber,
  dateConsultation,
  fraisEngagement,
}: DonneComplementairesType) => {
  const lang = useSelector(getLocaleSelector);
  const formatDate = dateConsultation
    ? format(Date.parse(dateConsultation), 'dd MMM yyyy ', {
        locale: lang === LANGUAGES.FR ? frLocale : arLocale,
      })
    : '';
  const intl = useIntl();

  return [
    {
      title: intl.formatMessage({ id: 'dmo.info.consultation.date' }),
      secondTitle: formatDate,
    },
    {
      title: intl.formatMessage({ id: 'dmo.info.frais' }),
      secondTitle: fraisEngagement,
    },
    {
      title: intl.formatMessage({ id: 'dmo.info.consultation.phone' }),
      secondTitle: telNumber,
    },
    {
      title: intl.formatMessage({ id: 'dmo.info.consultation.email' }),
      secondTitle: email,
    },
  ];
};

const RecapFolderProcess = () => {
  const {
    declareFolderProcessStepsState,
    foldersListState,
    concernedPeopleState,
    organismeListState,
  } = React.useContext(StoreContext);
  const { values } = useFormikContext<any>();
  const setStep = declareFolderProcessStepsState?.setDeclareFolderProcessSteps;
  const foldersList = foldersListState?.foldersList;
  const concernedPeople = concernedPeopleState?.concernedPeople;
  /* istanbul ignore next */
  const selectedTypeDossier = foldersTypeListMapping(foldersList).find(
    (item) => item.name === values.typeDossier,
  );
  /* istanbul ignore next */
  const selectedConcernedPeople = concernedPeopleMapping(concernedPeople).find(
    (item) => item.name === values.concernedPeople,
  );
  const isNotMobile = useMediaQuery('(min-width:960px)');

  /* istanbul ignore next */
  const getSelectedOrganismeName = () => {
    return organismeListState?.organismeList?.find(
      (org: { NUM_POLICE: any }) => org.NUM_POLICE === values.organisme,
    )?.NOM_SOUSCRIPTEUR;
  };
  const intl = useIntl();
  return (
    <div style={{ maxHeight: isNotMobile ? 350 : 470, overflow: 'auto' }}>
      <CardRecapComponent
        action={
          /* istanbul ignore next */ () => {
            setStep(0);
          }
        }
        title={intl.formatMessage({ id: 'dmo.step.1' })}
        content={
          <FolderTypeSecondaryContent>
            <PrimaryTitleCard>{getSelectedOrganismeName()}</PrimaryTitleCard>
          </FolderTypeSecondaryContent>
        }
      />

      <CardRecapComponent
        action={
          /* istanbul ignore next */ () => {
            setStep(1);
          }
        }
        title={intl.formatMessage({ id: 'dmo.step.2' })}
        content={
          <FolderTypeSecondaryContent>
            <Grid alignItems="center" container spacing={2}>
              <Grid item>
                <img
                  style={{ width: 30, height: 30 }}
                  src={
                    AssuranceIcon[
                      selectedTypeDossier ? selectedTypeDossier?.icon : ''
                    ]
                  }
                  alt=" icon - saham assurance"
                />
              </Grid>
              <Grid item>
                <PrimaryTitleCard>
                  {selectedTypeDossier?.label}
                </PrimaryTitleCard>
              </Grid>
            </Grid>
          </FolderTypeSecondaryContent>
        }
      />
      <CardRecapComponent
        action={
          /* istanbul ignore next */ () => {
            setStep(2);
          }
        }
        title={intl.formatMessage({ id: 'dmo.step.3' })}
        content={
          <FolderTypeSecondaryContent>
            <ContentLeft>
              <ContentTitle>{selectedConcernedPeople?.label}</ContentTitle>
            </ContentLeft>
            <ContentRight>
              <ContentSecondTitle>
                {selectedConcernedPeople?.secondTitle}
              </ContentSecondTitle>
            </ContentRight>
          </FolderTypeSecondaryContent>
        }
      />
      <CardRecapComponent
        action={
          /* istanbul ignore next */ () => {
            setStep(3);
          }
        }
        title={intl.formatMessage({ id: 'dmo.step.4' })}
        content={values.documentFiles?.map(
          /* istanbul ignore next */ (document: any, index: number) => (
            <UploadBoxRecap container style={{ marginBottom: 12 }}>
              <Grid item xs={2} style={{ maxWidth: 60 }}>
                <img src={get(AssuranceIcon, 'jpeg')} alt="jpeg" />
              </Grid>
              <Grid
                style={{ marginLeft: 5, marginRight: 5 }}
                item
                xs={8}
                sm={4}
              >
                <UploadBoxTitle>{'Document ' + (index + 1)}</UploadBoxTitle>
                <UploadBoxSecondTitle>
                  {formatBytes(document.file.size)}
                </UploadBoxSecondTitle>
              </Grid>
            </UploadBoxRecap>
          ),
        )}
      />
      <CardRecapComponent
        action={
          /* istanbul ignore next */ () => {
            setStep(4);
          }
        }
        title={intl.formatMessage({ id: 'dmo.step.5' })}
        content={
          <>
            {DonneComplementaires({
              email: values?.email,
              telNumber: values?.telNumber,
              dateConsultation: values?.dateConsultation,
              fraisEngagement: values?.fraisEngagement,
            }).map((item) => {
              return (
                <Grid
                  style={{
                    width: '90%',
                    marginTop: 15,
                    marginBottom: 15,
                    marginLeft: 20,
                  }}
                  container
                  alignItems="flex-start"
                  direction="column"
                >
                  <Grid item>
                    <ContentSecondTitle fontSize="14px">
                      {item.title}
                    </ContentSecondTitle>
                  </Grid>
                  <Grid item>
                    <ContentTitle fontSize="12px">
                      {item.secondTitle}
                    </ContentTitle>
                  </Grid>
                </Grid>
              );
            })}
          </>
        }
      />
    </div>
  );
};

export default RecapFolderProcess;
